import API_BASE_URL from '../config';
import React, { useState, useEffect } from 'react';
import MainModal from "./subcomponents/MainModal";
import TableTDE from "./subcomponents/TableTdE";
import { GLOBAL_CALCULATIONS } from './GlobalLogic';

const Reports = () => {
    const [allOrders, setAllOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [fetchagain,setFetchAgain] = useState(false);
    const [articles, setArticles] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const [reportlink, setReportLink] = useState("Work");
    const [namefield, setNameField] = useState("");
    const [amountfield, setAmountField] = useState("");
    const [removeZero, setRemoveZero] = useState(false);
    const [selecttoremove,setSelectToRemove] = useState(false);
    const [removedid, setRemovedId] = useState([]);

    const [modalon,setModalon] = useState(false);
    const [modalData, setModaldata] = useState({
            items:{},
            message:"Empty Message",
            modalcallback: ()=>{}
        });

    const [totalamount, setTotalAmount] = useState(0);
    
    const [sortConfig, setSortConfig] = useState({ key: 'dateoforder', direction: 'desc' });

        const checkitems = {
        "6":{
            "Selling Price":"sellingprice",
            "On Road Expense":"fabricsourcing",
            "Fabric":"fabric",
            "Fabric Dye":"fabricdye",
            "Dupatta":"dupatta",
            "Dupatta Dye":"dupattadye",
            "Fabric Dispatch":"fabricdispatch",
            "Work":"work",
            "Unstitched Dispatch":"unstitcheddispatch",
            "Stitching":"stitching",
            "Lases":"lases",
            "Stitched Dispatch":"stitcheddispatch",
            "Packaging Cost":"packagingcost",
            "Package Dispatch":"packagedispatched",
            "Courrier Fee":"courierfee"

        }
    };

    useEffect(() => {
        fetchData();
    }, [fetchagain]);

    const fetchData = async () => {
        try {
            const [ordersRes, articlesRes] = await Promise.all([
                fetch(`${API_BASE_URL}/ordershowa`),
                fetch(`${API_BASE_URL}/articleshowa`)
            ]);
            const ordersData = await ordersRes.json();
            const articlesData = await articlesRes.json();
            setAllOrders(ordersData);
            setFilteredOrders(ordersData); 
            setArticles(articlesData);
        } catch (err) {
            console.error("Error fetching report data:", err);
        }
    };

    useEffect(() =>{
        switch (reportlink) {
          case 'Work':
            setNameField("paygav")
            setAmountField("work");
            break
          case 'Stitching':
            setNameField("paystch")
            setAmountField("stitching");
            break
        case 'Balance':
            setNameField("payrec")
            setAmountField("payrec");
            break
        }
    }, [reportlink]);



    useEffect(() => {
        console.log(fetchagain,"Again Fetched");
        let results = allOrders.filter((o)=>{
            // console.log(o._id);
            if(reportlink==="Balance"){
                if((Number(o.sellingprice) - Number(o[amountfield])) > 0){
                    return true;
                };
            }else{
                if(!o[reportlink==="Work"?"paygav":"paystch"]){
                return true;
            }
            }
        });
        if (startDate && endDate) {
            results = results.filter(order => {
                if (!order.dateoforder) return false;
                const orderDate = new Date(order.dateoforder).getTime();
                const start = new Date(startDate).setHours(0, 0, 0, 0);
                const end = new Date(endDate).setHours(23, 59, 59, 999);
                return orderDate >= start && orderDate <= end;
            });
        }
        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            results = results.filter(order => 
                order.custname?.toLowerCase().includes(lowerSearch) ||
                order.articlename?.toLowerCase().includes(lowerSearch) ||
                order.odrsts?.toLowerCase().includes(lowerSearch) ||
                order.custphone?.includes(lowerSearch)
            );
        }

        if(removeZero){
            results = results.filter(order => {
                if(reportlink==="Balance"){
                    return true
                }else{
                    if(order[amountfield] !== 0){
                        return true
                    }
                }
            }
            );
        }

        if(!selecttoremove){
            removedid.filter(remid => {
                results = results.filter(order => 
                    remid !== order._id
                    );
                }
            );
        }

        const total = results.reduce((sum, o) => {
                if(reportlink==="Balance"){
                    return sum + (Number(o.sellingprice)-(Number(o[amountfield]) || 0))
                }
                return sum + (Number(o[amountfield]) || 0);
            }, 0);
            setTotalAmount(total);
        setFilteredOrders(results);
    }, [searchTerm, startDate, endDate, allOrders,namefield,amountfield,removeZero,selecttoremove]);

    const handleCheckboxChange = (e, orderId) => {
    const isChecked = e.target.checked;

    if (isChecked) {
        // 1. If checked, add the orderId to the array state
        setRemovedId((prevIds) => [...prevIds, orderId]);
    } else {
        // 2. If unchecked, remove the orderId from the array state
        setRemovedId((prevIds) => prevIds.filter((id) => id !== orderId));
    }
};

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
        setSortConfig({ key, direction });
    };

    const sortedOrders = React.useMemo(() => {
        let sortableItems = [...filteredOrders];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];
                if (sortConfig.key === 'balance') {
                    aValue = (Number(a.sellingprice) || 0) - (Number(a.payrec) || 0);
                    bValue = (Number(b.sellingprice) || 0) - (Number(b.payrec) || 0);
                }
                if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        return sortableItems;
    }, [filteredOrders, sortConfig]);

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return "↕️";
        return sortConfig.direction === 'asc' ? "🔼" : "🔽";
    };

    const resetFilter = () => {
        setStartDate(""); setEndDate(""); setSearchTerm(""); setRemoveZero(false); setSelectToRemove(false); setRemovedId([]);
        // setFilteredOrders(allOrders);
    };

    const onmodalinfo = (item, modalfunction) => {
    // 1. Map entries directly into a clean, readable list string
    const modalmessage = `${item.custname}'s ${item.articlename}`;

    // 2. Dynamically build the items object with keys and values
    const modalItemsObject = {};
    Object.entries(checkitems[6] || {}).forEach(([key, value]) => {
        modalItemsObject[key] = item[value];
    });

    // 3. Pass both the built object and the message into the state
    setModaldata({
        items: modalItemsObject, // Stores { key1: item[value1], key2: item[value2], ... }
        message: modalmessage,
        modalcallback: modalfunction,
        modalitem:item
    });
    setModalon(true);
};

const closemodal = ()=>{
    setModalon(false);
}

    const printReportContent = () => {
    const balanceCalculation = (order) => {
        return (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0);
    };

    // 1. Generate the absolute standalone HTML string
    const htmlContent = `
        <html>
            <head>
                <title>SUFNA - ${reportlink} Report</title>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                <style>
                    body { 
                        padding: 30px !important; 
                        background-color: #ffffff !important; 
                        color: #000000 !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    th { background-color: #f8f9fa !important; }
                    .card { border: 1px solid #dee2e6 !important; }
                </style>
            </head>
            <body>
                <div class="mb-4">
                    <h2 class="fw-bold">SUFNA</h2>
                    <h5 class="text-muted text-uppercase">${reportlink} Report Summary</h5>
                    <small>Generated on: ${new Date().toLocaleDateString('en-IN')}</small>
                    <hr />
                </div>

                <div class="card bg-light mb-4" style="max-width: 15rem;">
                    <div class="card-header fw-bold small text-muted">TOTAL AMOUNT</div>
                    <div class="card-body py-2">
                        <h2 class="mb-0 fw-bold">₹${totalamount}</h2>
                    </div>
                </div>

                <table class="table table-bordered align-middle">
                    <thead class="table-light">
                        <tr>
                            <th>Sr No.</th>
                            <th>Customer</th>
                            <th>Article</th>
                            <th>${reportlink} Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${sortedOrders.map((order, index) => `
                            <tr>
                                <td class="fw-bold">${index + 1}</td>
                                <td class="fw-bold">${order.custname || ''}</td>
                                <td>${order.articlename || ''}</td>
                                <td>₹${reportlink === "Balance" ? balanceCalculation(order) : (order[amountfield] || 0)}</td>
                                <td>${order.odrsts || ''}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
                
                <script>
                    // Self-executing print sequence inside the clean tab
                    window.onload = function() {
                        // Extra brief timeout to let Bootstrap CSS finalize styles
                        setTimeout(function() {
                            window.print();
                            // Optional: window.close(); // Closes tab after printing
                        }, 500);
                    };
                </script>
            </body>
        </html>
    `;

    // 2. Open a completely clean empty window/tab
    const printWindow = window.open('', '_blank');
    
    if (printWindow) {
        // 3. Inject content into it safely
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
    } else {
        alert("Please allow popups for this site to print reports on iPad.");
    }
};

    // --- INVOICE PRINT ---
    const printInvoice = (order) => {
        const balance = (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0);
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head><title>Invoice - ${order.custname}</title>
                <style>
                    body { font-family: sans-serif; padding: 40px; color: #333; }
                    .card { border: 1px solid #eee; padding: 30px; max-width: 650px; margin: auto; border-top: 10px solid black; }
                    .header { display: flex; justify-content: space-between; border-bottom: 2px solid #f4f4f4; padding-bottom: 20px; }
                    .brand { font-size: 34px; font-weight: 900; letter-spacing: 5px; }
                    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 30px; }
                    .label { color: #999; font-size: 10px; text-transform: uppercase; font-weight: bold; }
                    .value { font-size: 15px; margin-top: 2px; font-weight: 600; }
                    .total-box { margin-top: 40px; background: #f8f9fa; padding: 20px; border-radius: 10px; }
                    .footer { margin-top: 40px; text-align: center; font-size: 12px; color: #666; }
                </style></head>
                <body>
                    <div class="card">
                        <div class="header">
                            <div><div class="brand">SUFNA</div><div style="font-size:10px; letter-spacing:2px">DESIGNER BOUTIQUE | MOHALI</div></div>
                            <div style="text-align:right">
                                <div class="label">Invoice Date</div><div class="value">${new Date().toLocaleDateString('en-IN')}</div>
                            </div>
                        </div>
                        <div class="grid">
                            <div><div class="label">Customer</div><div class="value">${order.custname}</div></div>
                            <div><div class="label">Article</div><div class="value">${order.articlename}</div></div>
                            <div><div class="label">Status</div><div class="value">${order.odrsts}</div></div>
                            <div><div class="label">Tracking ID</div><div class="value">${order.odrtrack || 'PENDING'}</div></div>
                        </div>
                        <div class="total-box">
                            <div style="display:flex; justify-content:space-between; margin-bottom:5px;"><span>Total Price:</span><span>₹${order.sellingprice}</span></div>
                            <div style="display:flex; justify-content:space-between; color:green;"><span>Advance Paid:</span><span>₹${order.payrec}</span></div>
                            <hr/>
                            <div style="display:flex; justify-content:space-between; font-weight:bold; font-size:18px;"><span>Balance Due:</span><span>₹${balance}</span></div>
                        </div>
                        <div class="footer">
                            <p>Thank you for choosing SUFNA!</p>
                            <b>📞 +91 8968034945 | @sufna.__</b>
                        </div>
                    </div>
                    <script>window.print(); window.close();</script>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <ul className="nav nav-underline">
                        <li className="nav-item">
                            <a className={`nav-link ${reportlink==="Work"?"active":""}`} aria-current="page" href="#" onClick={()=>setReportLink("Work")}>Karigar Report</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${reportlink==="Stitching"?"active":""}`} href="#" onClick={()=>setReportLink("Stitching")}>Tailor Report</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${reportlink==="Balance"?"active":""}`} href="#" onClick={()=>setReportLink("Balance")}>Pending Payment Report</a>
                        </li>
                        {/* <li className="nav-item">
                            <a className={`nav-link ${reportlink==="karigar"?"active":""}`} href="#">Link</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${reportlink==="karigar"?"active":""}`} aria-disabled="true">Disabled</a>
                        </li> */}
                    </ul>
                    <button className="btn btn-dark shadow-sm px-4 fw-bold" onClick={() => printReportContent()}>🖨️ Print Page</button>
                </div>

                {/* SEARCH BAR */}
                <div className="card border-0 shadow-sm mb-4 p-3">
    <div className="row g-3 align-items-end">
        {/* SEARCH BAR */}
        <div className="col-lg-4 col-md-6">
            <label className="form-label small fw-bold text-muted text-uppercase">Search</label>
            <div className="input-group">
                <span className="input-group-text bg-white border-end-0 text-muted">🔍</span>
                <input 
                    type="text" 
                    className="form-control border-start-0 ps-0" 
                    placeholder="Search customer, article..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
        </div>

        {/* FROM DATE */}
        <div className="col-lg-2 col-md-3 col-6">
            <label className="form-label small fw-bold text-muted text-uppercase">From Date</label>
            <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </div>

        {/* TO DATE */}
        <div className="col-lg-2 col-md-3 col-6">
            <label className="form-label small fw-bold text-muted text-uppercase">To Date</label>
            <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>

        {/* MOBILE RESPONSIVE TOGGLE SWITCHES */}
        <div className="col-lg-3 col-md-9">
            <div className="row g-2">
                {/* Remove Zeros Toggle */}
                <div className="col-6">
                    <div className="form-check form-switch p-1 bg-light border rounded d-flex align-items-center justify-content-between px-2" style={{ minHeight: '38px' }}>
                        <label className="form-check-label small fw-bold text-muted text-uppercase mb-0 user-select-none ms-1 ps-1" htmlFor="removeZerosSwitch" style={{ fontSize: '0.75rem' }}>
                            Remove Zeros
                        </label>
                        <input 
                            className="form-check-input ms-0 me-1" 
                            type="checkbox" 
                            role="switch" 
                            id="removeZerosSwitch"
                            checked={removeZero} // Assuming 'removeZero' state variable name
                            onChange={(e) => setRemoveZero(e.target.checked)} // Assuming state handler
                        />
                    </div>
                </div>

                {/* Select to Remove Toggle */}
                <div className="col-6">
                    <div className="form-check form-switch p-1 bg-light border rounded d-flex align-items-center justify-content-between px-2" style={{ minHeight: '38px' }}>
                        <label className="form-check-label small fw-bold text-muted text-uppercase mb-0 user-select-none ms-1 ps-1" htmlFor="selectToRemoveSwitch" style={{ fontSize: '0.75rem' }}>
                            Select Remove
                        </label>
                        <input 
                            className="form-check-input ms-0 me-1" 
                            type="checkbox" 
                            role="switch" 
                            id="selectToRemoveSwitch"
                            checked={selecttoremove} // Adjust to your respective state name
                            onChange={(e) => setSelectToRemove(e.target.checked)} // Adjust to your respective handler
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* CLEAR BUTTON */}
        <div className="col-lg-1 col-md-3">
            <button className="btn btn-outline-secondary btn-sm-mobile w-100 fw-bold" style={{ height: '38px' }} onClick={resetFilter}>
                Clear
            </button>
        </div>
    </div>
</div>

                <div className="card text-bg-light mb-3" style={{ maxWidth: "18rem" }}>
                    <div className="card-header fw-bold">Total</div>
                    <div className="card-body">
                        <h1>{totalamount}</h1>
                    </div>
                </div>

                {/* TABLE */}
                <div className="card border-0 shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr style={{ cursor: 'pointer' }}>
                                        <th className="ps-4">Sr No.</th>
                                        <th onClick={() => requestSort('custname')}>Customer {getSortIcon('custname')}</th>
                                        <th onClick={() => requestSort('articlename')}>Article {getSortIcon('articlename')}</th>
                                        <th onClick={() => requestSort(reportlink==="Balance"?"balance":amountfield)}>{reportlink} {getSortIcon(amountfield)}</th>
                                        {/* <th onClick={() => requestSort('balance')}>Balance {getSortIcon('balance')}</th> */}
                                        <th onClick={() => requestSort('odrsts')}>Status {getSortIcon('odrsts')}</th>
                                        <th className="text-center pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedOrders.length > 0 ? sortedOrders.map((order,index) => {
                                        const balance = (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0);
                                        return (
                                            <tr key={order._id}>
                                                {selecttoremove?<td><input
                type="checkbox"
                className="form-check-input"
                id={`order-${order._id}`}
                // Dynamic check: box is active if the ID exists in the state array
                checked={removedid.includes(order._id)} 
                onChange={(e) => handleCheckboxChange(e, order._id)}
            /></td>:<td className="ps-4 small">{index+1}</td>}
                                                
                                                <td className="fw-bold" onClick={()=>onmodalinfo(order,()=>closemodal())}>{order.custname}</td>
                                                <td><span className="badge bg-light text-dark border">{order.articlename}</span></td>
                                                {reportlink==="Balance"?<td className="fw-bold">₹{balance}</td>:<TableTDE field = {amountfield} item={order} setFetchAgain={setFetchAgain}/>}
                                                {/* <td className={balance > 0 ? 'text-danger fw-bold' : 'text-success fw-bold'}>₹{balance}</td> */}
                                                <td><span className="badge bg-light text-primary border">{order.odrsts}</span></td>
                                                <td className="text-center pe-4">
                                                    <div className="btn-group">
                                                        <button className="btn btn-sm btn-outline-primary" title="Print Invoice" onClick={() => printInvoice(order)}>📄</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr><td colSpan="6" className="text-center py-5 text-muted">No records found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <MainModal
                isopen={modalon}
                onclose={() => setModalon(false)}
                items={modalData.items}
                modalitem={modalData.modalitem}
                message = {modalData.message}
                okfunction = {() => {
                    modalData.modalcallback();
                    setModalon(false);
                }
                }
                />
        </div>
    );
};

export default Reports;
